import React from "react";
import { useNavigate } from "react-router-dom";
import { button, text } from "../constants/tailwind-theme";
import check from '../assets/images/check.png'
import Header from "../components/Header";
import SelectTicketCard from "../components/SelectTicketCard";
import FooterWithText from "../components/FooterWithText";
import FooterWithSponsers from "../components/FooterWithSponsers";
import EventLogo from "../components/EventLogo";
import { twMerge } from 'tailwind-merge'
import { ref, onValue } from "firebase/database";

import { realtimeDb } from "../constants/firebase-config";

const ViewTicketsPage = (props) => {

  const navigate = useNavigate();
  const [selectedTicketIndex, setSelectedTicketIndex] = React.useState(0);
  const [isTicketsLoading, setIsTicketsLoading] = React.useState(false);

  const [dbTickets, setDbTickets] = React.useState([]);

  React.useEffect(() => {

    let mounted = true;

    if (!mounted) return;


    const ticketRef = ref(realtimeDb, 'tickets');
    setIsTicketsLoading(true);
    onValue(ticketRef, (snapshot) => {
      const data = snapshot.val();
      setDbTickets(data);
      setIsTicketsLoading(false)
    });


    return () => (mounted = false);

  }, []);

  return (
    <div className="flex flex-col">
      {/* HEADER */}
      <Header />

      {/* SECONDARY HEADING */}
      <div className="flex flex-row flex-wrap bg-secondary-500 border-0">

        {/* EVENT LOGO */}
        <div className="flex justify-center md:justify-end flex-wrap items-center md:w-6/12 w-full  p-4 md:pr-14 border-0">
          <EventLogo />
        </div>


        {/* EVENT DETAILS */}
        <div className="grow pl-4 py-8 border-0">
          <h1 className={twMerge(`${text.heading1} text-white md:text-start text-center `)}>Afrobeats Bazaar Festival </h1>
          <p className={twMerge(`${text.description1} text-tertiary-300 md:text-start text-center `)}>By Eykrom</p>
          <p className={twMerge(`${text.description1} text-tertiary-300 md:text-start text-center mt-8`)}>Saturday, 10th December 2022</p>
          <p className={twMerge(`${text.description1} text-tertiary-300 md:text-start text-center `)}>1pm till late</p>
          <p className={twMerge(`${text.description1} text-tertiary-300 md:text-start text-center mb-2`)}>Nubuke Foundation, East Legon</p>
          <div className="flex flex-row item-center justify-center md:justify-start">

            <a className={twMerge(`${button.default} pl-4 pt-3 w-40`)} href="https://www.google.com/maps/place/Nubuke+Foundation/@5.636297,-0.1747042,17z/data=!3m1!4b1!4m5!3m4!1s0x104056a267aead47:0xe9c6bccbfa7ad07c!8m2!3d5.636297!4d-0.1747042" target="_blank" rel="noopener noreferrer"> <span className={`${button.text}`}>{" "} Find Location</span></a>
          </div>


        </div>


      </div>



      {/* CONTENT */}
      <form className="container self-center my-8">
        <div className="flex flex-row flex-wrap justify-center p-4 md:space-x-8 bg-white">

          {isTicketsLoading ? <h2 className={twMerge(`${text.heading2} text-center`)}>Loading tickets...</h2> :
            <>
              {/* SELECT TICKET CARDs */}
              <div className="flex-col space-y-4 w-full md:w-5/12 mb-4 border-0">
                {dbTickets.map((ticket, index) => <SelectTicketCard index={index} selectedIndex={selectedTicketIndex} item={ticket} onClick={(index) => { setSelectedTicketIndex(index) }} />)}
                {/* {tickets.map((ticket, index) => <SelectTicketCard index={index} selectedIndex={selectedTicketIndex} item={ticket} onClick={(index) => { setSelectedTicketIndex(index) }} />)} */}
              </div>

              {/* TICKET PERKS */}
              <div className="flex flex-col space-y-8 w-full md:w-5/12 border border-tertiary-400 bg-tertiary-300 p-8">
                <h1 className={twMerge(`${text.heading1} text-center`)}>Included with {dbTickets[selectedTicketIndex]?.ticket_name} </h1>

                <div>
                  {
                    dbTickets[selectedTicketIndex]?.ticket_perks?.map((perk, index) =>
                      <p className={twMerge(`${text.description1} mb-1`)}> <img className=" inline w-5 h-5 mr-1" src={check} alt="" /> {perk}</p>)
                  }

                </div>

                {/* DISABLE BUTTON IF REMAINING TICKET IS 0 */}
                <button
                  disabled={dbTickets[selectedTicketIndex]?.ticket_remaining === 0}
                  onClick={(event) => { event.preventDefault(); navigate("/checkout", { state: { ticketIndex: selectedTicketIndex , ticket: dbTickets[selectedTicketIndex]} }); }}
                  type="submit"
                  className={twMerge(`${button.default} w-full disabled:bg-tertiary-400`)}>

                  <p className={twMerge(`${button.text}`)}>
                    {dbTickets[selectedTicketIndex]?.ticket_remaining === 0 ? "SOLD OUT" : "BUY " + dbTickets[selectedTicketIndex]?.ticket_name + " TICKET"}
                  </p>

                </button>


              </div>
            </>
          }


        </div>
      </form>


      <FooterWithText />

      <FooterWithSponsers />

    </div>
  );
};

export default ViewTicketsPage;
